/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_You_BadgeInputs */



/**
* | output |
* | --- |
* | "You" |
*
* @param {Team_Manager_You_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_you_badge = /** @type {((inputs?: Team_Manager_You_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_You_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tu")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tú")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("你")
	if (locale === "ja") return /** @type {LocalizedString} */ ("あなた")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Você")
	return /** @type {LocalizedString} */ ("You")
});